/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Daftar_S3Inputs */

const en_mk_tut_daftar_s3 = /** @type {(inputs: Mk_Tut_Daftar_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same button also creates the account for someone who has never signed up — there is no separate registration form.`)
};

const id_mk_tut_daftar_s3 = /** @type {(inputs: Mk_Tut_Daftar_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tombol yang sama sekaligus membuat akun untuk orang yang belum pernah mendaftar — tidak ada formulir pendaftaran terpisah.`)
};

/**
* | output |
* | --- |
* | "The same button also creates the account for someone who has never signed up — there is no separate registration form." |
*
* @param {Mk_Tut_Daftar_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_daftar_s3 = /** @type {((inputs?: Mk_Tut_Daftar_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Daftar_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_daftar_s3(inputs)
	return en_mk_tut_daftar_s3(inputs)
});